import axios from "axios";

let BASE_URL;

if (process.env.NODE_ENV === "production") {
    BASE_URL = "https://dla.lenda.co.zw";
}else {
    BASE_URL = "http://localhost:8000";
}

let WS_BASE_URL;

if (process.env.NODE_ENV === "production") {
    WS_BASE_URL = "wss://dla.lenda.co.zw/ws";
}else {
    WS_BASE_URL = "ws://localhost:8000/ws";
}

export { WS_BASE_URL };

export default axios.create({
    baseURL: BASE_URL
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { "Content-Type": "application/json" },
    withCredentials: true
});